
























































































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import NotificationTemplateDetailBase from "./NotificationTemplateDetailBase";

	@Component
	export default class NotificationTemplateDetail extends NotificationTemplateDetailBase {

		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
		}

		//Vzor doplnit napovedu
		//	searchAll = [{ id: 1, text: 'Ales' }, { id: 2, text: 'Jan' }, { id: 3, text: 'Mirek' }, { id: 4, text: 'Dan' }
		//,{ id: 5, text: 'Alena' },];

		mounted() {
			super.mounted();
		};

		created() {
			super.initializeRights('COR_NotificationTemplate_Create', 'COR_NotificationTemplate_Delete', 'COR_NotificationTemplate_Read', 'COR_NotificationTemplate_Update');
            super.setMainDescription('notificationTemplate.new', 'notificationTemplate.detail');
			this.initEnum();
			if (this.styleFormNew) {
				this.started = true;
			}
		}

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
        }

        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
        }

		validate() {
			return this.validateBase();
		}

		isCorrectType(value: any) {
			this.isCorrectTypeBase(value);
		}

        isCorrectSubject(value: any) {
            this.isCorrectSubjectBase(value);
		}

        isCorrectBody(value: any) {
            this.isCorrectBodyBase(value);
        }


	}
